import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetRubricsQueryResponse, GetRubricsQueryParams } from "../types/GetRubrics";

export const getRubricsQueryKey = (params?: GetRubricsQueryParams) =>     [{url:`/api/ms-content-infoportal-backend/v1/rubrics`},...(params ? [params] : [])] as const;
      export function getRubricsQueryOptions <TData = GetRubricsQueryResponse, TError = unknown>(params?: GetRubricsQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getRubricsQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/ms-content-infoportal-backend/v1/rubrics`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/ms-content-infoportal-backend/v1/rubrics
 */

export function useGetRubrics <TData = GetRubricsQueryResponse, TError = unknown>(params?: GetRubricsQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getRubricsQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getRubricsQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
